import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function PricingSection() {
  return <section className="w-full bg-brand-bg pt-6 md:pt-8 pb-8 md:pb-10 px-6" data-id="element-202">
      <div className="max-w-4xl mx-auto" data-id="element-203">
        <motion.div className="flex flex-col md:flex-row gap-6" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-204">
          {/* Pricing card */}
          <div className="flex-1 bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-lg shadow-brand-green/5" data-id="element-205">
            {/* Banner */}
            <div className="bg-brand-green py-3 text-center" data-id="element-206">
              <span className="text-white text-sm font-bold uppercase tracking-widest" data-id="element-207">
                Lanzamiento Argentina
              </span>
            </div>

            <div className="px-8 py-10 text-center" data-id="element-208">
              <p className="text-lg font-semibold text-gray-900 mb-6" data-id="element-209">
                Acceso inmediato a la guía
              </p>

              <div className="mb-6" data-id="element-210">
                <p className="text-xl text-gray-400 line-through mb-2" data-id="element-211">
                  $150.000 ARS
                </p>
                <p className="flex items-baseline justify-center gap-1" data-id="element-212">
                  <span className="text-lg text-gray-400" data-id="element-213">$</span>
                  <span className="text-5xl md:text-6xl font-bold text-gray-900" data-id="element-214">
                    19.900
                  </span>
                  <span className="text-lg text-gray-500 ml-1" data-id="element-215">ARS</span>
                </p>
                <p className="text-sm font-semibold text-brand-green mt-4" data-id="element-216">
                  Precio lanzamiento por tiempo limitado
                </p>
              </div>

              <a href="https://www.emprende-digital.com/cart/51742249156888:1" target="_blank" rel="noopener noreferrer" className="block w-full max-w-xs mx-auto bg-brand-green hover:bg-brand-green-hover text-white font-bold text-lg py-4 rounded-xl transition-colors duration-200 shadow-lg shadow-brand-green/20 text-center mb-6" data-id="element-217">
                🔥 Acceder Ahora
              </a>

              {/* Divider */}
              <div className="border-t border-dashed border-gray-200 my-6" data-id="element-218" />

              {/* Sistema Completo option */}
              <p className="text-lg font-semibold text-gray-900 mb-4" data-id="element-219">
                Sistema Completo
              </p>
              <p className="flex items-baseline justify-center gap-1 mb-4" data-id="element-220">
                <span className="text-lg text-gray-400" data-id="element-221">$</span>
                <span className="text-4xl md:text-5xl font-bold text-gray-900" data-id="element-222">
                  49.900
                </span>
                <span className="text-lg text-gray-500 ml-1" data-id="element-223">ARS</span>
              </p>
              <a href="https://www.emprende-digital.com/cart/51868533883160:1" target="_blank" rel="noopener noreferrer" className="block w-full max-w-xs mx-auto bg-gray-900 hover:bg-gray-800 text-white font-bold text-lg py-4 rounded-xl transition-colors duration-200 shadow-lg text-center mb-4" data-id="element-224">
                🚀 Sistema Completo
              </a>

              <p className="text-sm text-gray-500 mb-2" data-id="element-225">
                Actualizaciones incluidas +{' '}
                <strong className="text-gray-700" data-id="element-226">
                  Acceso a toda la información que necesitas
                </strong>
              </p>
              <p className="text-sm text-gray-400" data-id="element-227">
                Pago 100% seguro • Mercado Pago
              </p>
              <p className="text-sm text-gray-600 mt-3" data-id="element-228">
                🎁 + de regalo 3 bonos valorados en $25.000 totalmente{' '}
                <strong className="text-brand-green" data-id="element-229">¡GRATIS!</strong>
              </p>
              <p className="text-sm text-gray-500 mt-2" data-id="element-230">
                📩 Acceso inmediato al eBook después del pago, se envía a tu
                correo electrónico
              </p>
            </div>
          </div>

          {/* Benefits card */}
          <div className="md:w-64 bg-brand-card rounded-2xl border border-gray-200 p-8 flex flex-col justify-center shadow-sm" data-id="element-231">
            <div className="space-y-6" data-id="element-232">
              <div className="flex items-start gap-3" data-id="element-233">
                <CheckIcon className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-234" />
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-235">
                  Único pago. Sin suscripciones ni pagos extra.
                </p>
              </div>

              <div className="border-t border-dashed border-gray-200" data-id="element-236" />

              <div className="flex items-start gap-3" data-id="element-237">
                <CheckIcon className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-238" />
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-239">
                  Entrás hoy y empezás a aplicar en horas (aunque no tengas
                  experiencia).
                </p>
              </div>

              <div className="border-t border-dashed border-gray-200" data-id="element-240" />

              <div className="flex items-start gap-3" data-id="element-241">
                <CheckIcon className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-242" />
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-243">
                  Acceso inmediato + guía paso a paso.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}